<!--
해외주문상세 안에있는 상품리스트의 일괄기능
 - 컨트롤러를 따로 사용하지 않기때문에,
   컨트롤러의 선택상품숫자 표현하는 기능까지 같이 구현함.
------------------------------------
-->
<template>
    <div
        class="wrapper"
        :uk-sticky="onSticky && itemCheckedCount > 0"
    >
        <div class="uk-flex uk-flex-left uk-flex-bottom">
            <button
                class="uk-button uk-button-primary uk-margin-right"
                type="button"
                :disabled="disabled"
                v-on:click="$refs.trackingno.jobInit()"
            >
                <i class="material-icons">local_shipping</i>
                트래킹번호 입력
            </button>

            <!-- 선택개수안내 -->
            <div class="selected-msg" v-show="itemCheckedCount > 0" v-html="itemCheckedInfo"></div>

            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg" v-show="itemCheckedCount === 0">
                {{ batch.item_checked_nothing_msg }}
            </div>



        </div>

        <!-- 트래킹번호 기능 -->
        <tracking-no
            ref="trackingno"
            :batch="batch"
            :csrfToken="csrfToken"
        ></tracking-no>

    </div>

</template>

<script>
    import checkedCountable from '../../checked-countable';
    import stickiable from '../../stickable';

    export default {
        mixins: [
            checkedCountable,
            stickiable,
        ],
        components: {
            'tracking-no': require('../prod/tracking-no.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

        },
        data: function () {

            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: #fff;
        border: 1px solid #999;
        padding: 0.5rem;
    }
</style>